import type { ReactElement } from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'
import { Redirect } from 'react-router-dom'
import { UserPage, UserGroupPage } from '.'
import UserSideMenu from '../../components/Users/SideMenu'
import { BaseLayout } from '../../layouts'

const UserRouter = (): ReactElement => {
  const { path } = useRouteMatch()

  return (
    <BaseLayout menu={<UserSideMenu />}>
      <Switch>
        <Route path={`${path}`} exact>
          <Redirect to={`${path}/users`} />
        </Route>
        <Route exact path={`${path}/users`}>
          <UserPage />
        </Route>
        <Route exact path={`${path}/user-groups`}>
          <UserGroupPage />
        </Route>
      </Switch>
    </BaseLayout>
  )
}

export default UserRouter
